import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { GET } from "../../api/requests";
import { shipmentDbCols } from "../../definitions/db_cols";
import { useParams } from "react-router";
import { useQuery } from "react-query";
import AppLoading from "../../components/EmptyLoadingStates/AppLoading";

export default function SharedShipment({ id }) {
  const { supabase, token } = useContext(AuthContext);
  const { rectangleId } = useParams();
  const {
    data: shipment,
    isError,
    isLoading,
    error,
  } = useQuery(
    ["shipment", rectangleId],
    () => {
      return GET(`/shipments/${rectangleId}`);
    },
    {
      enabled: !!supabase && !!rectangleId && !!token, // only run the query if supabase is truthy, regardless of inboxName being empty or not
    }
  );
  if (shipment) {
    return (
      <div className="bg-white">
        <div className="border-b border-gray-100">
          <div
            style={{ maxWidth: 900 }}
            className="flex items-center justify-start py-4 mx-auto"
          >
            <div className="">
              <img style={{ width: 120 }} src={"/logo_bw.png"} />
            </div>
          </div>
        </div>

        <div
          className="mx-auto grid grid-cols-share-grid"
          style={{ maxWidth: 900 }}
        >
          <div className="pt-6 border-r border-gray-100  bg-white ">
            <h1 className="text-lg font-bold font-space text-gray-700">
              Real-time shipment info
            </h1>
            <dl className="divide-y divide-gray-100">
              {Object.keys(shipmentDbCols).map((colKey) => (
                <div className="py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                  <dt className="text-xs font-medium truncate leading-6 text-gray-900">
                    {colKey}
                  </dt>
                  {shipment.data[colKey] ? (
                    <dd className="mt-1 text-sm leading-6 text-gray-600 sm:col-span-2 sm:mt-0">
                      {shipment.data[colKey] || "———"}
                    </dd>
                  ) : (
                    <dd className="mt-1 text-sm leading-6 text-gray-200 sm:col-span-2 sm:mt-0">
                      {shipment.data[colKey] || "———"}
                    </dd>
                  )}
                </div>
              ))}
            </dl>
          </div>
          <div className="px-8">
            <h1 className="text-lg pt-6 font-bold font-space text-gray-700">
              Shipment history
            </h1>
          </div>
        </div>
      </div>
    );
  } else {
    return <AppLoading />;
  }
}
